import React, { useState } from "react";
import { BrowserRouter as Router, Link, useHistory } from "react-router-dom";
import "antd/dist/antd.min.css";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Host from "../../Components/Host";
import { useGetUserDataQuery } from "../../services/login";
import PhoneIcon from "@mui/icons-material/Phone";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function Footer() {
  const { userId, userToken, userEmail, userName, isMember, mediaLang, countryCode, languageCode } = useSelector(
    (state) => state.auth
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  // const tabbyCurrencies = ['AED', 'SAR', 'KWD', 'BHD', 'QAR']
  const tabbyCurrencies = ["AED", "SAR"];

  const adFooterRef = React.useRef(null);
  React.useEffect(() => {
    if (window.location.hostname === "en-dxb.thwifty.com") {
      if (window.adsbygoogle && adFooterRef.current && !adFooterRef.current.dataset.loaded) {
        try {
          window.adsbygoogle.push({});
          adFooterRef.current.dataset.loaded = "true"; // mark as loaded
        } catch (e) {
          console.error("Adsense error-footer", e);
        }
      }
    }
  }, []);

  return (
    <div className="Footer-page" style={{ position: "absolute", bottom: "0px", width: "100%", height: "0rem" }}>
      <div style={{ padding: "10px", background: "#000", borderBottom: "1px solid #202020" }}>
        <div className="container">
          <div
            className="ftr-time-section"
            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}
          >
            <div className="ftr-time-card" style={{ display: "flex", alignItems: "center" }}>
              <InfoOutlinedIcon style={{ fontSize: "26px", color: "#fff" }} />
              <div className="ftr-time-item" style={{ fontSize: "14px", margin: "0px 10px", color: "#fff" }}>
                <strong style={{ fontSize: "13px" }}>{t("customer_support_available")}</strong>
                <br />
                8AM to 10PM Dubai Time (7 Days a Week)
              </div>
            </div>

            <div>
              <div
                className="ftr-time-card"
                style={{ display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "center" }}
              >
                {/* <div style={{ fontSize: '14px', fontWeight: 500, margin: '0 10px' }}>{t('support')}:</div> */}
                <div className="ftr-time-item" style={{ display: "flex", alignItems: "center", margin: "0 5px" }}>
                  <span>
                    <MailOutlineIcon style={{ fontSize: "22px", color: "#fff" }} />
                  </span>
                  <span style={{ margin: "0 7px", fontSize: "14px", color: "#fff" }}>{Host?.email}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="Footer-menu-card1">
        <div className="container">
          <div className="Footer-menu-card fp-mp" style={{ paddingBottom: "40px" }}>
            <div className="Footer-menu-item">
              <Link to="/about-us">
                <img src={Host?.domainLogo} style={{ width: "310px" }} />
              </Link>
              <a href="https://www.trustpilot.com/review/rockmycart.com" target="_blank">
                <div
                  style={{
                    background: "#fff0",
                    justifyContent: "center",
                    borderRadius: "8px",
                    padding: "16px 20px",
                    textAlign: "center",
                    fontFamily: "sans-serif",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      marginBottom: "8px",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src="https://cdn.trustpilot.net/brand-assets/4.3.0/logo-white.svg"
                      style={{ width: "180px" }}
                    />
                  </div>
                  <div>
                    <div style={{ display: "flex", gap: "2px", justifyContent: "center", marginBottom: "6px" }}>
                      {[1, 2, 3, 4, 5].map((i) => {
                        const filled = 3.5 >= i ? 1 : 3.5 >= i - 1 ? 3.5 - (i - 1) : 0;
                        const id = `grad-${i}`;
                        return (
                          <svg key={i} width="24" height="24" viewBox="0 0 24 24">
                            <defs>
                              <linearGradient id={id}>
                                <stop offset={`${filled * 100}%`} stopColor="#f97316" />
                                <stop offset={`${filled * 100}%`} stopColor="#e5e7eb" />
                              </linearGradient>
                            </defs>
                            <polygon
                              points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
                              fill={`url(#${id})`}
                            />
                          </svg>
                        );
                      })}
                    </div>
                    <p style={{ margin: 0, fontSize: "13px", color: "#555", textAlign: "center" }}>
                      <strong>{3.5}</strong> out of {5}
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="Footer-menu-item">
              {/* <h5 style={{ padding: "5px", color: "#fff" }}>{t("contact")}</h5> */}
              <div className="Footer-menu-SubItem">
                <div style={{ lineHeight: 2 }}>
                  <Link to="/contact-us">
                    <h5 style={{ color: "#fff" }}>Business Information</h5>
                  </Link>

                  <p>
                    Trade License: Online World FZ LLC <br />
                    License Number: 7007570
                  </p>

                  <p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: Host?.address,
                      }}
                    ></div>
                    <MailOutlineIcon style={{ fontSize: "1.1rem", color: "#fff" }} />
                    &nbsp; {Host?.email} <br />
                    <PhoneIcon style={{ fontSize: "1.1rem", color: "#fff" }} />
                    &nbsp; {Host?.phone}
                  </p>
                  <p>
                    <strong>Website: {window.location.hostname}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="Footer-menu-item">
              <h5 style={{ padding: "5px", color: "#fff" }}>{t("helpful_links")}</h5>
              <div className="Footer-menu-SubItem">
                <Link to="/shipping-policy">{t("shipping_policy")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/payment-policy">{t("payment_policy")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/returns-and-refund">{t("return_refunds")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/privacy-policy">{t("privacy_policy")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/terms-and-conditions">{t("terms_and_conditions")}</Link>
              </div>
            </div>
            <div className="Footer-menu-item">
              <h5 style={{ padding: "5px", color: "#fff" }}>{t("about")}</h5>
              <div className="Footer-menu-SubItem">
                <Link to="/about-us">{t("about_us")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/contact-us">{t("contact_us")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/careers">{t("careers")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/faqs">{t("faqs")}</Link>
              </div>
              <div className="Footer-menu-SubItem">
                <Link to="/track-order">{t("track_order")}</Link>
              </div>
            </div>
          </div>
          <div className="Footer-menu-card" style={{ borderTop: "1px solid #202020" }}>
            <div className="Footer-menu-item Footer-menu-bottom" style={{ justifyContent: "space-between" }}>
              <div className="Footer-menu-subcard">
                <div className="Footer-menu-SubItem">
                  © {new Date().getFullYear()} {Host?.domainName === "rockmycart" ? "Rock My Cart" : Host?.domainName} |{" "}
                  {t("all_right_reserved")}
                </div>
                <div className="Footer-menu-SubItem">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span style={{ margin: "0 5px" }}>
                      <svg
                        width="30px"
                        viewBox="0 0 24 16"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xlink="http://www.w3.org/1999/xlink"
                      >
                        <g id="319" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="New-Icons" transform="translate(-80.000000, -280.000000)" fillRule="nonzero">
                            <g id="Card-Brands" transform="translate(40.000000, 200.000000)">
                              <g id="Color" transform="translate(0.000000, 80.000000)">
                                <g id="Visa" transform="translate(40.000000, 0.000000)">
                                  <rect
                                    id="Container"
                                    strokeOpacity="0.2"
                                    stroke="#000000"
                                    strokeWidth="0.5"
                                    fill="#FFFFFF"
                                    x="0.25"
                                    y="0.25"
                                    width="23.5"
                                    height="15.5"
                                    rx="2"
                                  ></rect>
                                  <path
                                    d="M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z"
                                    id="Shape"
                                    fill="#1434CB"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </span>
                    <span style={{ margin: "0 5px" }}>
                      <svg viewBox="0 0 24 16" width="29px" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fillRule="evenodd">
                          <rect fill="#252525" height="16" rx="2" width="24" />
                          <circle cx="9" cy="8" fill="#eb001b" r="5" />
                          <circle cx="15" cy="8" fill="#f79e1b" r="5" />
                          <path
                            d="m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z"
                            fill="#ff5f00"
                          />
                        </g>
                      </svg>
                    </span>
                    <span style={{ margin: "0 5px" }}>
                      <svg width="30px" viewBox="0 -11 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M33.0603 31.5161V25.4741H36.1786C37.4564 25.4741 38.535 25.046 39.4142 24.2015L39.6252 23.9875C41.2313 22.2391 41.1258 19.5155 39.4142 17.898C38.5584 17.0416 37.3861 16.5778 36.1786 16.6016H31.1729V31.5161H33.0603ZM33.0605 23.6425V18.4332H36.2262C36.9063 18.4332 37.5512 18.6948 38.0319 19.1706C39.052 20.1696 39.0754 21.8347 38.0905 22.8694C37.6098 23.3809 36.9297 23.6663 36.2262 23.6425H33.0605ZM48.4293 22.1083C47.6204 21.359 46.5185 20.9784 45.1234 20.9784C43.3298 20.9784 41.9816 21.6444 41.0906 22.9646L42.7553 24.0231C43.3649 23.1192 44.1973 22.6673 45.2524 22.6673C45.9206 22.6673 46.5653 22.9171 47.0694 23.369C47.5618 23.7972 47.8432 24.4156 47.8432 25.0698V25.5098C47.1163 25.1055 46.2019 24.8914 45.0765 24.8914C43.7635 24.8914 42.7084 25.2006 41.923 25.831C41.1375 26.4613 40.739 27.2939 40.739 28.3524C40.7155 29.3158 41.1258 30.2316 41.8527 30.85C42.5912 31.5161 43.5291 31.8491 44.631 31.8491C45.9323 31.8491 46.9639 31.2663 47.7494 30.1007H47.8314V31.5161H49.6368V25.2244C49.6368 23.9042 49.2382 22.8576 48.4293 22.1083ZM43.3066 29.6369C42.9197 29.3514 42.6852 28.8876 42.6852 28.3881C42.6852 27.8291 42.9432 27.3652 43.4473 26.9965C43.9632 26.6278 44.6081 26.4375 45.3702 26.4375C46.4255 26.4256 47.2462 26.6635 47.8325 27.1392C47.8325 27.948 47.5159 28.6497 46.8945 29.2444C46.3317 29.8153 45.5696 30.1364 44.7723 30.1364C44.2446 30.1483 43.7287 29.9699 43.3066 29.6369ZM53.693 35.9999L60.0001 21.3114H57.9485L55.0295 28.6378H54.9943L52.0049 21.3114H49.9534L54.0916 30.8619L51.747 35.9999H53.693Z"
                          fill="#3C4043"
                        />
                        <path
                          d="M26.544 24.1659C26.544 23.5831 26.4971 23.0003 26.4034 22.4294H18.4434V25.7239H23.0037C22.8161 26.7825 22.2065 27.734 21.3155 28.3286V30.4695H24.0353C25.6296 28.9828 26.544 26.7825 26.544 24.1659Z"
                          fill="#4285F4"
                        />
                        <path
                          d="M18.4442 32.539C20.7185 32.539 22.6411 31.7778 24.0361 30.4695L21.3164 28.3287C20.5544 28.852 19.5814 29.1493 18.4442 29.1493C16.2403 29.1493 14.3763 27.6388 13.7081 25.6169H10.9062V27.8291C12.3365 30.7193 15.2555 32.539 18.4442 32.539Z"
                          fill="#34A853"
                        />
                        <path
                          d="M13.708 25.6169C13.3563 24.5584 13.3563 23.4048 13.708 22.3343V20.134H10.9058C9.69808 22.5484 9.69808 25.4029 10.9058 27.8172L13.708 25.6169Z"
                          fill="#FBBC04"
                        />
                        <path
                          d="M18.4442 18.8019C19.6517 18.7781 20.8123 19.242 21.6798 20.0864L24.0948 17.6363C22.559 16.1853 20.5427 15.3885 18.4442 15.4123C15.2555 15.4123 12.3365 17.2439 10.9062 20.134L13.7081 22.3462C14.3763 20.3124 16.2403 18.8019 18.4442 18.8019Z"
                          fill="#EA4335"
                        />
                      </svg>
                    </span>
                    <span style={{ margin: "0 5px" }}>
                      <svg width="30px" viewBox="0 -11 70 70" fill="none">
                        <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9" />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M19.1601 16.6863C18.5726 17.3901 17.6325 17.9452 16.6924 17.8659C16.5749 16.9143 17.0352 15.9032 17.5737 15.2787C18.1613 14.5551 19.1895 14.0397 20.0219 14C20.1198 14.9913 19.7379 15.9627 19.1601 16.6863ZM20.012 18.0542C19.1838 18.006 18.4281 18.3064 17.8177 18.549C17.4249 18.7051 17.0923 18.8373 16.8392 18.8373C16.5552 18.8373 16.2089 18.6981 15.82 18.5417L15.82 18.5417L15.82 18.5417L15.82 18.5417C15.3104 18.3368 14.7278 18.1025 14.1169 18.1137C12.7166 18.1335 11.4142 18.9365 10.6993 20.2152C9.23044 22.7726 10.3174 26.5593 11.7373 28.6409C12.4326 29.6718 13.265 30.8018 14.3617 30.7622C14.8442 30.7438 15.1913 30.5947 15.5505 30.4404C15.9641 30.2628 16.3937 30.0782 17.0645 30.0782C17.712 30.0782 18.1228 30.2579 18.5172 30.4305C18.8921 30.5945 19.2522 30.752 19.7868 30.7424C20.9227 30.7225 21.6376 29.7115 22.3328 28.6806C23.0831 27.5741 23.4129 26.4943 23.4629 26.3304L23.4688 26.3114C23.4676 26.3102 23.4583 26.3059 23.4419 26.2984C23.1911 26.1821 21.274 25.2937 21.2557 22.9114C21.2372 20.9118 22.7762 19.8987 23.0185 19.7392C23.0332 19.7295 23.0432 19.723 23.0477 19.7196C22.0684 18.2525 20.5408 18.0939 20.012 18.0542ZM27.8755 30.6333V15.1796H33.6041C36.5615 15.1796 38.6277 17.2414 38.6277 20.2548C38.6277 23.2683 36.5223 25.3499 33.5258 25.3499H30.2453V30.6333H27.8755ZM30.2451 17.2018H32.9772C35.0336 17.2018 36.2087 18.312 36.2087 20.2648C36.2087 22.2175 35.0336 23.3377 32.9674 23.3377H30.2451V17.2018ZM46.452 28.7797C45.8253 29.989 44.4445 30.7523 42.9561 30.7523C40.7527 30.7523 39.2153 29.424 39.2153 27.4217C39.2153 25.4391 40.7038 24.2992 43.4555 24.1307L46.4128 23.9522V23.0998C46.4128 21.8409 45.6 21.1569 44.1508 21.1569C42.9561 21.1569 42.0845 21.7814 41.9083 22.733H39.7735C39.842 20.7307 41.7026 19.2735 44.2193 19.2735C46.9318 19.2735 48.6945 20.7108 48.6945 22.9412V30.6333H46.501V28.7797H46.452ZM43.5924 28.9185C42.3292 28.9185 41.5262 28.3039 41.5262 27.3622C41.5262 26.3908 42.2998 25.8257 43.7785 25.7365L46.4127 25.568V26.4403C46.4127 27.8876 45.1984 28.9185 43.5924 28.9185ZM55.9702 31.238C55.0204 33.9442 53.9334 34.8363 51.6224 34.8363C51.4461 34.8363 50.8585 34.8165 50.7214 34.7768V32.9232C50.8683 32.943 51.2307 32.9628 51.4167 32.9628C52.4645 32.9628 53.0521 32.5167 53.4144 31.357L53.6298 30.673L49.6149 19.4222H52.0924L54.8833 28.5517H54.9322L57.7231 19.4222H60.1321L55.9702 31.238Z"
                          fill="#000000"
                        />
                      </svg>
                    </span>
                    <span style={{ margin: "0 5px" }}>
                      <svg fill="#1574d2" width="25px" viewBox="0 0 576 512">
                        <path d="M0 432c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48v-1.1H514.3l-31.9-35.1-31.9 35.1H246.8V267.1H181L262.7 82.4h78.6l28.1 63.2V82.4h97.2L483.5 130l17-47.6H576V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80V432zm440.4-21.7L482.6 364l42 46.3H576l-68-72.1 68-72.1H525.4l-42 46.7-41.5-46.7H390.5L458 338.6l-67.4 71.6V377.1h-83V354.9h80.9V322.6H307.6V300.2h83V267.1h-122V410.3H440.4zm96.3-72L576 380.2V296.9l-39.3 41.4zm-36.3-92l36.9-100.6V246.3H576V103H515.8l-32.2 89.3L451.7 103H390.5V246.1L327.3 103H276.1L213.7 246.3h43l11.9-28.7h65.9l12 28.7h82.7V146L466 246.3h34.4zM282 185.4l19.5-46.9 19.4 46.9H282z" />
                      </svg>
                    </span>
                    {/* {tabbyCurrencies?.includes(userData?.contant?.currency) && (
                      <img src="/tabby-logo-1.png" style={{ width: "50px", margin: "0px 5px", padding: 0 }} />
                    )} */}
                  </div>
                </div>
              </div>

              <div className="Footer-menu-subcard">
                <div className="Footer-menu-SubItem">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ margin: "0 4px" }}>{t("country")}: </span>
                      <img
                        style={{ margin: "0 4px", padding: "0px" }}
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${countryCode?.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${countryCode?.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      <span style={{ margin: "0 2px" }}>{userData?.contant?.country}</span>
                    </div>
                  </div>
                </div>
                <div className="Footer-menu-SubItem">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ margin: "0 4px" }}>{t("currency")}: </span>
                      <span style={{ margin: "0 5px" }}>{userData?.contant?.currency}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
